var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import Manager from '@shared/modal/Manager';
import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { useLanguage } from '../../base/LanguageProvider';
import { useTagContext } from '../../data/tag/tagContext';
import { FormField, FormFieldLabel, FormTextInput } from '../../styled/Form';
import { ModalBody } from '../../styled/Modal';
import { startGlobalLoading, stopGlobalLoading } from '../loading/globalLoading';
import Modal from '../modal/Modal';
import ModalFooter from '../modal/ModalFooter';
import ModalHeader from '../modal/ModalHeader';
import Tags from '../tags/Tags';
function CopyFromModal(props) {
    var e_1, _a;
    var _this = this;
    var tagIdsSelection = props.tagIdsSelection, accTagId = props.accTagId, invalidate = props.invalidate, copyCellsHandler = props.copyCellsHandler;
    var _b = __read(useState(accTagId ? [accTagId] : []), 2), sourceTagIds = _b[0], setSourceTagIds = _b[1];
    var _c = __read(useState('0'), 2), offset = _c[0], setOffset = _c[1];
    var L = useLanguage().L;
    var tagData = useTagContext().tagData;
    var tags = [];
    try {
        for (var sourceTagIds_1 = __values(sourceTagIds), sourceTagIds_1_1 = sourceTagIds_1.next(); !sourceTagIds_1_1.done; sourceTagIds_1_1 = sourceTagIds_1.next()) {
            var id = sourceTagIds_1_1.value;
            var tag = tagData.tagById[id];
            if (tag !== undefined) {
                tags.push(tag);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (sourceTagIds_1_1 && !sourceTagIds_1_1.done && (_a = sourceTagIds_1.return)) _a.call(sourceTagIds_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    function removeTagHandler(tagId) {
        var filteredTagIds = sourceTagIds.filter(function (id) { return id !== tagId; });
        setSourceTagIds(filteredTagIds);
    }
    function selectTagHandler(tagId) {
        if (sourceTagIds.includes(tagId)) {
            return;
        }
        setSourceTagIds(__spreadArray(__spreadArray([], __read(sourceTagIds), false), [tagId], false));
    }
    return (React.createElement(Modal, { width: 400 },
        React.createElement(ModalHeader, { title: L('Copy Data From') }),
        React.createElement(ModalBody, null,
            React.createElement("form", null,
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Offset in Months')),
                    React.createElement(FormTextInput, { value: offset, onChange: function (e) {
                            setOffset(e.target.value);
                        } })),
                React.createElement(FormField, { "$bottomSpace": true },
                    React.createElement(FormFieldLabel, null, L('Source Tags')),
                    React.createElement(Tags, { tags: tags, remove: removeTagHandler, select: selectTagHandler })))),
        React.createElement(ModalFooter, { done: function () { return __awaiter(_this, void 0, void 0, function () {
                var offs, error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            offs = Number(offset);
                            if (isNaN(offs) || !isFinite(offs)) {
                                return [2 /*return*/];
                            }
                            startGlobalLoading();
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, copyCellsHandler({ offset: offs, sourceTagIds: sourceTagIds, targetTagIds: tagIdsSelection })];
                        case 2:
                            _a.sent();
                            invalidate();
                            toast.success(L("Cells copied!"));
                            Manager.closeModal();
                            return [3 /*break*/, 5];
                        case 3:
                            error_1 = _a.sent();
                            toast.error(L('Failed to copy cells') + error_1.message ? ': ' + error_1.message : '');
                            return [3 /*break*/, 5];
                        case 4:
                            stopGlobalLoading();
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            }); } })));
}
export default CopyFromModal;
